import { render, staticRenderFns, recyclableRender, components } from "./PreviewSvga.vue?vue&type=template&id=e4302652&scoped=true&"
var renderjs
import script from "./PreviewSvga.vue?vue&type=script&lang=js&"
export * from "./PreviewSvga.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSvga.vue?vue&type=style&index=0&id=e4302652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4302652",
  null,
  false,
  components,
  renderjs
)

export default component.exports